"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M27 10.35h-7.35v-3.7H22v-1.3h-6v1.3h2.35v18.7H16v1.3h6v-1.3h-2.35v-3.7H27A2.65 2.65 0 0 0 29.65 19v-6A2.65 2.65 0 0 0 27 10.35zM28.35 19A1.36 1.36 0 0 1 27 20.35h-7.35v-8.7H27A1.36 1.36 0 0 1 28.35 13zM2.35 13v6A2.65 2.65 0 0 0 5 21.65h8v-1.3H5A1.36 1.36 0 0 1 3.65 19v-6A1.36 1.36 0 0 1 5 11.65h8v-1.3H5A2.65 2.65 0 0 0 2.35 13z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M6 15.35h7v1.3H6z"
})));
module.exports = exports.default;